<fin-titled-card
  *ngIf="enableUpsellMMB && category === Category.CABIN_BAGGAGE && !isInfant"
  [title]="
    'MMB.includedProducts.cabinBaggage.capacityTitle'
      | finLocalization
        : {
            amount: cabinWeight,
          }
  "
>
  <ng-container *ngTemplateOutlet="serviceList"></ng-container>
</fin-titled-card>

<div *ngIf="enableUpsellMMB && category === Category.CABIN_BAGGAGE && isInfant">
  <div class="flex">
    <button
      [attr.aria-controls]="'infant-allowance-title'"
      [attr.aria-expanded]="expandOpen"
      class="fill flex no-outline"
      (click)="expandOpen = !expandOpen"
    >
      <div class="font-body-1 bold-type nordic-blue-300-text ms-xlarge-l">
        {{ 'MMB.includedProducts.cabinBaggage.infantAllowance' | finLocalization }}
      </div>
      <fcom-icon
        class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text ms-medium-l"
        [class.rotate-active]="expandOpen"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      ></fcom-icon>
    </button>
  </div>
  <fcom-expand
    class="block"
    [open]="expandOpen"
    [ariaId]="'infant-allowance-title'"
    [ariaLabelledBy]="'infant-allowance-item'"
  >
    <div class="flex flex--column">
      <ng-container *ngTemplateOutlet="serviceList"></ng-container>
    </div>
  </fcom-expand>
</div>

<ng-container *ngIf="!enableUpsellMMB || category !== Category.CABIN_BAGGAGE">
  <ng-container *ngTemplateOutlet="serviceList"></ng-container>
</ng-container>

<ng-template #serviceList>
  <ul class="no-list-style">
    <li *ngFor="let cat of filteredGroupedServices; let first = first" [class.ps-xsmall-t]="!first">
      <div
        class="flex flex--middle"
        [class.ms-medium-l]="enableUpsellMMB"
        *ngIf="(enableUpsellMMB && !isInfant) || !enableUpsellMMB"
      >
        <fcom-icon *ngIf="cat.icon" [name]="cat.icon" class="icon-medium ms-xsmall-r"></fcom-icon>
        <div class="font-body-1 medium-type" *ngIf="cat.key !== 'availableForSell'">
          {{ 'MMB.includedProducts.serviceCategory.' + cat.key + '.title' | finLocalization }}
        </div>
        <div
          class="flex ms-small-l ms-medium-r flex-1 flex--space-between"
          *ngIf="(enableUpsellMMB || isShoppingCart) && cat.key === 'pendingPayment'"
        >
          <button
            *ngIf="!loading && (cat.showActionsButtons || isShoppingCart)"
            [attr.data-testid]="'modify-button-' + this.category"
            class="view-details nordic-blue-900-text underline font-body-1 bold-type"
            (click)="onSelectProduct()"
          >
            {{ 'actions.modify' | finLocalization }}
          </button>
          <div *ngIf="loading">
            <fin-loader [type]="LoaderType.INLINE_TEXT"></fin-loader>
          </div>
          <button
            *ngIf="!loading && cat.showActionsButtons && !isShoppingCart"
            class="view-details nordic-blue-900-text underline font-body-1 bold-type"
            (click)="continuePurchase.emit(true)"
          >
            {{ 'actions.pay' | finLocalization }}
          </button>
        </div>
      </div>

      <ul class="accommodate-icon list-disc-style">
        <li *ngFor="let service of cat.services; let last = last">
          <div class="flex flex--wrap flex--align-start flex--self-stretch">
            <span
              class="regular-type"
              *ngIf="cat.key !== 'availableForSell'"
              [ngClass]="{
                fill: isShoppingCart,
                'pr-small-b': !last && isShoppingCart,
                'mr-xsmall-r': !isShoppingCart,
              }"
            >
              <ng-container
                [ngTemplateOutlet]="category === Category.SEAT && !service.seatNumber ? seatTags : serviceNameTemplate"
                [ngTemplateOutletContext]="{ serviceInfo: { service, pendingPayment: cat.key === 'pendingPayment' } }"
              ></ng-container>
            </span>
            <div
              class="flex flex--space-between"
              *ngIf="enableUpsellMMB && cat.key === 'availableForSell'"
              [ngClass]="{
                'flex--column': isMobile$ | async,
                'flex--row flex-1': (isMobile$ | async) === false,
              }"
            >
              <span class="regular-type mr-xsmall-r grey-600-text">
                {{ 'MMB.includedProducts.availableForSell.' + service.subCategory + '.text' | finLocalization }}
              </span>
              <fcom-button
                class="ms-xxsmall-t"
                text="{{
                  'MMB.includedProducts.availableForSell.' + service.subCategory + '.add'
                    | finLocalization
                      : {
                          amount: service.totalPrice | finPrice,
                        }
                }}"
                [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                [loading]="loading"
                (click)="onSelectProduct()"
              ></fcom-button>
            </div>
            @if (service.includedInTierBenefit && service.parameters?.isCorporate) {
              <fcom-tag>
                <fcom-icon [name]="SvgLibraryIcon.B2B" class="icon-medium ms-xxsmall-r"></fcom-icon>
                <span class="regular-type">
                  {{ 'MMB.includedProducts.corporateBenefitTag' | finLocalization }}
                </span>
              </fcom-tag>
            } @else if (cat.tierLevel && service.includedInTierBenefit) {
              <fcom-tag>
                <fcom-icon [name]="SvgLibraryIcon.FINNAIR_PLUS" class="icon-medium ms-xxsmall-r"></fcom-icon>
                <span class="regular-type">{{
                  'MMB.includedProducts.chip.text' | finLocalization: { tier: cat.tierLevel }
                }}</span>
              </fcom-tag>
            }
          </div>
        </li>
      </ul>
    </li>
  </ul>
</ng-template>

<ng-template #seatTags let-serviceInfo="serviceInfo">
  <fcom-tag *ngIf="isCarrierConnect">
    <fcom-icon [name]="SvgLibraryIcon.INFO_BLOCK" class="icon-small ms-xxsmall-r"></fcom-icon>
    <span class="regular-type">{{ 'MMB.services.seat.checkBoardingPassStatus' | finLocalization }}</span>
  </fcom-tag>
  <fcom-tag
    *ngIf="isNotIncludedService(serviceInfo.service) && !isCarrierConnect && !enableUpsellMMB"
    [theme]="TagTheme.WARNING"
  >
    <fcom-icon [name]="SvgLibraryIcon.ALERT_TRIANGLE" class="icon-small ms-xxsmall-r"></fcom-icon>
    <span class="regular-type">{{ 'MMB.services.seat.assignedAtAirportStatus' | finLocalization }}</span>
  </fcom-tag>
  <ng-container
    *ngIf="!isNotIncludedService(serviceInfo.service) && !isCarrierConnect"
    [ngTemplateOutlet]="serviceNameTemplate"
    [ngTemplateOutletContext]="{ serviceInfo: serviceInfo }"
  ></ng-container>
</ng-template>

<ng-template #serviceNameTemplate let-serviceInfo="serviceInfo">
  <ng-container
    *ngIf="!isShoppingCart"
    [ngTemplateOutlet]="serviceListing"
    [ngTemplateOutletContext]="{ service: serviceInfo.service }"
  >
  </ng-container>
  <div
    class="flex ms-small-l flex-1 flex--space-between"
    [ngClass]="{ 'mr-xsmall-r': isShoppingCart }"
    *ngIf="isShoppingCart && serviceInfo.pendingPayment"
  >
    <ng-container
      [ngTemplateOutlet]="serviceListing"
      [ngTemplateOutletContext]="{ service: serviceInfo.service }"
    ></ng-container>
    <div *ngIf="loading">
      <fin-loader [type]="LoaderType.INLINE_TEXT"></fin-loader>
    </div>
    <div
      *ngIf="isShoppingCart"
      [attr.data-testid]="
        'service-price-' +
        this.category +
        '-' +
        (this.category === Category.SEAT ? serviceInfo.service.seatNumber : serviceInfo.service.variant)
      "
      class="bold-type font-heading-5"
    >
      {{ serviceInfo.service.totalPrice | finPrice }}
    </div>
  </div>
  <div class="flex ms-small-l flex-1 flex--end" *ngIf="isShoppingCart && serviceInfo.pendingPayment">
    <div *ngIf="loading">
      <fin-loader [type]="LoaderType.INLINE_TEXT"></fin-loader>
    </div>
    <fcom-button
      [attr.data-testid]="
        'remove-service-button-' +
        this.category +
        '-' +
        (this.category === Category.SEAT ? serviceInfo.service.seatNumber : serviceInfo.service.variant)
      "
      *ngIf="!loading && isShoppingCart"
      [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
      [icon]="{ category: IconLibrary.SVG_LIBRARY, name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
      [loading]="serviceInfo.service.removeInProgress"
      [text]="'MMB.reviewPage.service.removeButtonTitle' | finLocalization"
      [disabled]="serviceInfo.service.removeInProgress === false && serviceRemovalInProgress"
      (clickBtn)="onRemoveProduct(serviceInfo.service)"
    >
    </fcom-button>
  </div>
</ng-template>

<ng-template #serviceListing let-service="service">
  {{
    service.includedInTierBenefit
      ? service.displayName
      : ('MMB.includedProducts.' + service.subCategory + '.text'
        | finLocalization
          : {
              seatNumber: service.seatNumber,
              amount: service.quantity,
              weight: service.parameters?.baggageWeight,
              displayName: service.displayName,
            }
        | finEmpty: service.displayName)
  }}
</ng-template>
